import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Shared proxies"),
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://cdn.proxyscrape.com/img/section-shape.png",
      alt: "section-shape"
    }),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Share the link with anyone."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("The proxies are updated every minute"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" according to the settings used before sharing. ")
    ])
  ])
], -1)
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "itemcard wp" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "sharethis-inline-share-buttons" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  id: "downloadbtn",
  type: "submit",
  onclick: "savetofile()",
  class: "btn btn-blue",
  style: {"width":"100%","display":"none"}
}, " Download ", -1)

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const content = ref('');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("textarea", {
              style: {"min-height":"450px","max-height":"1000px","min-width":"100%"},
              id: "proxyshare",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event))
            }, "\n              Loading...\n            ", 512), [
              [_vModelText, content.value]
            ]),
            _hoisted_7
          ])
        ])
      ])
    ])
  ]))
}
}

})